import React, { Component } from 'react';
import arrowPointerIcon from "assets/images/icon_arrow_pointer.svg";
import deletePhotoIcon from "assets/images/g2234.svg";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from "states/appState";
import "./tab2.scss";
import * as Lang from "./Tab2Lang";
import Button from "_modules/button/Button";
import Button1 from "_modules/button1/Button1";
import ReactSVG from 'react-svg';
import * as LocalApi from "_services/LocalApi";

export class View extends Component {

    constructor(props) {
        super(props);

        this.state = {
            fullImageUrl: null
        }

        this.fileHandle = null;
        this.fileRequestId = 0;
        this.unmounted = false;
    }

    componentDidMount() {
        this.getFileURL();
    }

    componentDidUpdate(prevProps) {
        if(prevProps.probeImage.file_id !== this.props.probeImage.file_id ||
            prevProps.appState.currentIncidentId !== this.props.appState.currentIncidentId) {
            this.getFileURL();
        }
    }

    componentWillUnmount() {
        this.unmounted = true;
        this.fileRequestId += 1;
        LocalApi.releaseFile(this.fileHandle);
        this.fileHandle = null;
    }

    replaceFile = fileHandle => {
        LocalApi.releaseFile(this.fileHandle);
        this.fileHandle = fileHandle;
        this.setState({
            fullImageUrl: fileHandle ? fileHandle.url : null
        });
    }

    getFileURL = (props = this.props) => {
        const requestId = ++this.fileRequestId;
        this.replaceFile(null);

        if(props.probeImage.file_id === 0) {
            return Promise.resolve(null);
        }

        return LocalApi.getFile(
            props.probeImage.file_id,
            props.appState.currentIncidentId
        ).then((fileHandle) => {
            if(this.unmounted || requestId !== this.fileRequestId) {
                LocalApi.releaseFile(fileHandle);
                return null;
            }

            this.replaceFile(fileHandle);
            return fileHandle;
        });
    }
    
    render = () => {
        const arr = this.props.probeImage.arrow;
        const st = {
            'top': arr.y + "px",
            'left': arr.x + "px",
            'transform': "rotate(" + arr.rotation + "deg)",
            width: '50px',
            height: '50px'
        }

        return (
            <div key={this.props.key} className="pic">
                <img alt="" src={this.state.fullImageUrl} />

                {arr.show &&
                    <ReactSVG style={st} alt="" className="img-arr" src={arrowPointerIcon} />
                }

                {false &&
                <div className="btm">
                    <div className="btn-upl">
                        <Button photoIndex={this.props.key} className="button btn-photo" label={Lang.BTN_PHOTO} />
                        <input onChange={(ev) => {
                            const files = ev.target.files || ev.dataTransfer.files;
                            if (files.length)
                                this.props.changePhoto(this.props.probeImage);
                        }} className="fl" type="file"></input>
                    </div>

                    <Button1 photoIndex={this.props.key} onClick={this.deletePhoto} className="button button1 btn-delete" img={deletePhotoIcon} />
                </div>
                }
            </div>
        )
    }
}

export default connect(
    state => state,
    dispatch => ({
        actions: bindActionCreators(actions, dispatch),
    })
)(View);
